/* AQUA by Glamzzo — page behaviour, loaded only by the aqua-* sections (template product.aqua).
   - One shared offer state (1 or 2 pieces) for every offer selector on the page.
   - The selected quantity is written to EasySell's documented quantity hook (name="es-quantity-picker")
     and to the product form, then EasySell's own button is triggered, so EasySell opens with that quantity
     and selects its matching quantity-offer tier.
   - Mobile sticky order bar, gallery dots, FAQ accordions, light reveal animations. */
(function () {
  'use strict';
  if (window.__aquaInit) return;
  window.__aquaInit = true;

  var root = document.documentElement;
  root.classList.add('aqua-page');

  var dataEl = document.getElementById('aqua-offer-data');
  var data = { offers: {}, currency: 'DH' };
  try { if (dataEl) data = JSON.parse(dataEl.textContent); } catch (e) {}

  var state = { qty: 1 };

  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatPrice(qty) {
    var offer = data.offers && data.offers[String(qty)];
    return offer ? offer.price + ' ' + data.currency : '';
  }

  function setQty(qty, source) {
    qty = parseInt(qty, 10);
    if (qty !== 1 && qty !== 2) return;
    state.qty = qty;
    $all('input[data-aqua-offer]').forEach(function (input) {
      var match = parseInt(input.value, 10) === qty;
      if (input !== source) input.checked = match;
    });
    $all('[name="es-quantity-picker"], #aqua-product-form [name="quantity"]').forEach(function (input) {
      input.value = String(qty);
    });
    $all('[data-aqua-bar-price]').forEach(function (el) { el.textContent = formatPrice(qty); });
    // If the EasySell form is already open, keep its quantity-offer tier in step.
    if (isModalOpen() && typeof window.ES_SELECT_OFFER_BY_QUANTITY === 'function') {
      try { window.ES_SELECT_OFFER_BY_QUANTITY(qty); } catch (e) {}
    }
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (input && input.matches && input.matches('input[data-aqua-offer]')) setQty(input.value, input);
  });

  /* ---------- Order buttons -> EasySell ---------- */
  function nativeEasySellButton() {
    return document.querySelector('.aqua-easysell-host #es-popup-button') ||
      document.querySelector('.aqua-easysell-host .es-popup-button') ||
      document.getElementById('es-popup-button');
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest ? event.target.closest('[data-aqua-order]') : null;
    if (!trigger) return;
    event.preventDefault();
    setQty(state.qty);
    var native = nativeEasySellButton();
    if (native) {
      native.click();
    } else {
      // EasySell not loaded yet: bring the visitor back to the offer selector instead of doing nothing.
      var hero = document.getElementById('aqua-offers-hero');
      if (hero) hero.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  /* ---------- EasySell modal detection ---------- */
  var modalEl = null;
  function isModalOpen() {
    modalEl = modalEl || document.getElementById('easysell-modal');
    if (!modalEl) return false;
    var cs = window.getComputedStyle(modalEl);
    return cs.display !== 'none' && cs.visibility !== 'hidden';
  }

  /* ---------- Mobile sticky bar ---------- */
  var bar = document.querySelector('[data-aqua-bar]');
  var heroZone = document.querySelector('[data-aqua-hero-zone]');
  var heroOut = false;

  function updateBar() {
    if (!bar) return;
    var show = heroOut && !isModalOpen();
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    $all('a, button', bar).forEach(function (el) { el.tabIndex = show ? 0 : -1; });
    root.classList.toggle('aqua-bar-on', show && window.matchMedia('(max-width: 749px)').matches);
  }

  if (bar && heroZone && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        heroOut = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      });
      updateBar();
    }, { threshold: 0 }).observe(heroZone);
  }

  // Watch the EasySell modal (it is injected by the app, possibly after this script runs).
  var queued = false;
  var modalWatcher = new MutationObserver(function () {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      if (!modalEl) modalEl = document.getElementById('easysell-modal');
      updateBar();
    });
  });
  modalWatcher.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
  window.addEventListener('resize', updateBar);

  /* ---------- Gallery dots ---------- */
  $all('[data-aqua-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('.aqua-gallery__track');
    var items = $all('.aqua-gallery__item', gallery);
    var dots = $all('.aqua-gallery__dot', gallery);
    if (!track || !dots.length) return;
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var item = items[i];
        if (!item) return;
        var start = item.offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingInlineStart || 0);
        track.scrollTo({ left: start, behavior: 'smooth' });
      });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
            var idx = items.indexOf(entry.target);
            dots.forEach(function (d, j) { d.setAttribute('aria-current', j === idx ? 'true' : 'false'); });
          }
        });
      }, { root: track, threshold: [0.6] });
      items.forEach(function (item) { io.observe(item); });
    }
  });

  /* ---------- FAQ ---------- */
  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest ? event.target.closest('.aqua-faq__q') : null;
    if (!btn) return;
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (panel) panel.hidden = open;
  });

  /* ---------- Reveal ---------- */
  var reveals = $all('.aqua-reveal');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var rio = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); obs.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach(function (el) { rio.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  // Initial state: 1 piece (as specified), unless the visitor already picked another option (back/forward cache).
  var checked = document.querySelector('input[data-aqua-offer]:checked');
  setQty(checked ? checked.value : 1);
  updateBar();
})();
